// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { SubmissionAnswer } from './submissionAnswer.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class RelayPayload {
    'ccid': string;
    'customer_id': string;
    'journey_id': string;
    'trigger_id': string;
    'message_id': string;
    'product_group_id': string;
    'form_id': string;
    'date_submitted_at': string;
    'relay_tracking_id': string;
    'client_message_tag': string;
    'client_trigger_id': string;
    'secondary_account_id': string;
    'submission_id': string;
    'submission': Array<SubmissionAnswer>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof RelayPayload>> = [
        {
            "name":     "ccid",
            "baseName": "ccid",
            "type":     "string"
        },
        {
            "name":     "customer_id",
            "baseName": "customer_id",
            "type":     "string"
        },
        {
            "name":     "journey_id",
            "baseName": "journey_id",
            "type":     "string"
        },
        {
            "name":     "trigger_id",
            "baseName": "trigger_id",
            "type":     "string"
        },
        {
            "name":     "message_id",
            "baseName": "message_id",
            "type":     "string"
        },
        {
            "name":     "product_group_id",
            "baseName": "product_group_id",
            "type":     "string"
        },
        {
            "name":     "form_id",
            "baseName": "form_id",
            "type":     "string"
        },
        {
            "name":     "date_submitted_at",
            "baseName": "date_submitted_at",
            "type":     "string"
        },
        {
            "name":     "relay_tracking_id",
            "baseName": "relay_tracking_id",
            "type":     "string"
        },
        {
            "name":     "client_message_tag",
            "baseName": "client_message_tag",
            "type":     "string"
        },
        {
            "name":     "client_trigger_id",
            "baseName": "client_trigger_id",
            "type":     "string"
        },
        {
            "name":     "secondary_account_id",
            "baseName": "secondary_account_id",
            "type":     "string"
        },
        {
            "name":     "submission_id",
            "baseName": "submission_id",
            "type":     "string"
        },
        {
            "name":     "submission",
            "baseName": "submission",
            "type":     "Array<SubmissionAnswer>"
        },
    ];

    static getAttributeTypeMap() {
        return RelayPayload.attributeTypeMap;
    }
}
